<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Manage Products in Bulk</h1>
      <h2>1. How do I manage products in bulk?</h2>
      <ul>
        <li>
          Go to the Products Management page and click “Bulk Update Products Via
          CSV.”
        </li>
        <li>
          Download the CSV template, update your product information (e.g.,
          commission rates, status), and upload it back to Artemis Ads.
        </li>
      </ul>
      <p>That’s it! Your products will be updated in bulk.</p>
      <h2>
        2. Will updating products on Artemis Ads affect my Amazon listings?
      </h2>
      <p>No.</p>
      <p>
        Updating products on Artemis Ads does not change anything on Amazon.
        Your Amazon listings remain unaffected.
      </p>
      <h2>3. What if I need help?</h2>
      <p>
        Contact us at Support@ArtemisAds.com for assistance with bulk product
        management.
      </p>
      <h2>Quick Tip</h2>
      <ul>
        <li>
          Use the CSV template to update products quickly and efficiently.
        </li>
        <li>
          Make sure you use the right amazon seller account information, keep
          the data/time format consistent as the original template.
        </li>
      </ul>
      <img
        src="seller/manage-products-in-bulk.png"
        alt="ArtemisAds help center"
      />
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>